import React from "react";
import DomainSetter from "../components/DomainName/DomainSetter";
import WorkflowSetter from "../components/Settings/WorkflowSetter";

const Settings = () => {
    return (
      <div style={{ padding: '20px' }}>
        <DomainSetter />
        <WorkflowSetter />
      </div>
    );
  };
  
  export default Settings;